import { useUiStore } from "@/stores/useUiStore";
import { TransitionGuard } from "@/components/ui/modals/TransitionGuard";
import type { ReactNode } from "react";

// ─── Transition Guard ─────────────────────────────────────────────────────────

const TRANSITIONS = {
  'shake': { message: 'Ready to shake? You won\'t be able to change your spices after this.',    continueText: 'Shake it!',  cancelText: 'Not yet'  },
  'reset': { message: 'Starting over? This will clear everything and you\'ll restart your blend.', continueText: 'Yes, clear', cancelText: 'Keep it'  },
} as const;

export type TransitionType = keyof typeof TRANSITIONS;

export function useTransitionGuard() {
  const openTransition  = useUiStore(s => s.openTransition);
  const closeTransition = useUiStore(s => s.closeTransition);

  const trigger = (type: TransitionType, callbacks: { onContinue: () => void; onCancel?: () => void }) => {
    const config = TRANSITIONS[type];
    openTransition({
      ...config,
      onContinue: () => { closeTransition(); callbacks.onContinue(); },
      onCancel:   () => { closeTransition(); callbacks.onCancel?.(); },
    });
  };

  return { trigger };
}

// ─── Transitions Provider ─────────────────────────────────────────────────────

export function Transitions({ children }: { children: ReactNode }) {
  return (
    <>
      <TransitionGuard />
      {children}
    </>
  );
}
